var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noMain"},[_c('img',{attrs:{"src":require("../assets/images/noData.png")}}),_vm._t("default",[_vm._v("暂无数据")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }